export const handleDomain = (code?: string) => {
  if (code) {
    // eslint-disable-next-line no-useless-concat
    return code + "." + "mbet8.net";
  }
  return "mbet8.net";
};
